import { render, staticRenderFns } from "./testYourRep.vue?vue&type=template&id=0ec20d00&scoped=true"
import script from "./testYourRep.vue?vue&type=script&lang=js"
export * from "./testYourRep.vue?vue&type=script&lang=js"
import style0 from "./testYourRep.vue?vue&type=style&index=0&id=0ec20d00&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ec20d00",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/workspaces/wuwow-junior-vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0ec20d00')) {
      api.createRecord('0ec20d00', component.options)
    } else {
      api.reload('0ec20d00', component.options)
    }
    module.hot.accept("./testYourRep.vue?vue&type=template&id=0ec20d00&scoped=true", function () {
      api.rerender('0ec20d00', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/event/newYear2024/components/testYourRep.vue"
export default component.exports